import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';

import 'Lib/jquery.scrolltofixed';

"use strict";

var ViewCart = Backbone.View.extend({

  initialize: function (opts) {
    var self = this;
    self.$content = self.$el;
    self.$cartDetail = self.$content.find('.cart-detail');
    self.$cartSummary = self.$content.find('.cart-summary');

    self.initQuantitySelects();
    self.initRemoveLinks();
    self.scrollIndicator();
    self.cartTotalsFix();
    self.countCharacters();
  },

  events: {},

  makeUpdateAjaxConfig: function (id, quantity) {
    return {
      contentType: 'application/json',
      data: JSON.stringify({ id: id, quantity: quantity }),
      dataType: 'json',
      type: 'POST',
      url: '/cart/change.js',
    }
  },

  scrollIndicator: function(){
    ///Scroll To Top - Use this js doc for all application specific JS
    $.fn.scrollHelp=function(){		
      $("#toTop").hide().removeAttr("href");
      if($(window).scrollTop()!="0"){  $(this).fadeOut(300)  }
      var scrollDiv=$(this);
      $(window).scroll(function(){
        if($(window).scrollTop()=="0"){	$(scrollDiv).fadeIn(300)  }else{  $(scrollDiv).fadeOut(300)	}
      });
      $(this).click(function(){
        $("html, body").animate({scrollTop:0},400,function(){$(scrollDiv).fadeIn(300);});
      });
    }
    $(".scroll-indicator").scrollHelp();
  },
      
  cartTotalsFix: function(){
      var self = this;
      var marginOffset = 0;
      var $elemToFix = self.$cartSummary;
      
      self.$currentFixItems = false;
      
      if (!self.isMobile()) {
          self.$currentFixItems = $elemToFix.scrollToFixed({
              removeOffsets: true,
              spacerClass: 'fixed',
              // marginTop: $('.site-header').outerHeight(),
              fixed: function(){
                  $(this).removeClass('unFixed');
                  $(this).addClass('isFixed');
              },
              unfixed: function() {
                  $(this).removeClass('isFixed');
                  $(this).addClass('unFixed');
              },
              limit: function() {
                  var limit = $('.site-footer').offset().top - $elemToFix.outerHeight() - marginOffset;
                  // console.log('limit at ' + limit);
                  if (!limit) {
                      limit = 0.01;
                  }
                  return limit;
              },
              zIndex: 1,
          });
      }
      
  },

  formatMoney: function (money) {
    return Shopify.formatMoney(money, theme.moneyFormat)
  },

  setCartGlobalValues: function (cart) {
    var subtotal = this.formatMoney(cart.items_subtotal_price);
    $('#cart-total-price').html(subtotal);

    $('#item-count').html(cart.item_count);
  },

  handleItemQuantityChanged: function (event, cart, itemKey) {
    this.setCartGlobalValues(cart);

    for (var i in cart.items) {
      var item = cart.items[i];

      if (item.key === itemKey) {
        var $line = this.$('tr[data-item-key="' + item.key + '"]');
        console.log($line, $line.find('td .remove'), $line.find('td .remove'));
        $line.find('td .remove').attr('data-quantity', item.quantity);
        break;
      }
    }
  },

  initQuantitySelects: function () {
    $('.select-wrapper select[name="updates[]"]').each((function (i, select) {
      var quantityWas = +select.value;

      select.addEventListener('change', (function (e) {
        if ('noadd' in select.dataset) {
          delete select.dataset.noadd;
          return;
        };

        var itemKey = select.dataset.itemKey;
        var quantityIs = +select.value;

        var $lines = $(select).closest('tbody').find('tr[data-item-key]');
        var line = $(select).closest('tr[data-item-key]').index($lines) + 1;

        $.ajax(this.makeUpdateAjaxConfig(itemKey, quantityIs))
          .done((function (cart) {
            var item = cart.items.find(function (item) {
              return item.key === itemKey;
            });

            if (item.quantity !== quantityIs) {
              select.value = item.quantity.toString();
              select.dataset.noadd = '';

              select.dispatchEvent(
                new Event('change'),
                { bubles: true, cancelable: false }
              );
            }

            this.handleItemQuantityChanged(event, cart, itemKey);
            quantityWas = +select.value;
            window.ajaxCart && window.ajaxCart.load();

            $('body').trigger('afterChangeItem.ajaxCart', [ line, +select.value, cart ]);

            // Show alert if trying to add more than max available quantity
            if (quantityIs > quantityWas) {
              alert('Maximum quantity available has been added')
            }
          }).bind(this))
          .fail((function () {
            select.value = quantityWas.toString();
            select.dataset.noadd = '';

            select.dispatchEvent(
              new Event('change'),
              { bubles: true, cancelable: false }
            );
          }));
      }).bind(this));
    }).bind(this));
  },

  countCharacters: function () {
    $('#gift-note').on("keyup", function(){
      var characterCount = $(this).val().length,
      currentCount = $('#currentCount'),
      theCount = $('#char-count');
      currentCount.text(characterCount);
    })
  
  },

  handleItemDeleted: function (cart, itemKey) {
    this.setCartGlobalValues(cart);
    var $item = this.$el.find('.item-row[data-item-key="' + itemKey + '"]');

    // animate removal of item
    $item.css('opacity', '0');
    setTimeout(function () { $item.remove(); if ($('.sg-addon-item').length == 0) { $('.sg-widget-state').removeClass('has-donation');} }, 1000);
  },

  removeLinkClickHandler: function (event) {
    var itemKey = $(event.target).data('item-key');

    if ($(event.currentTarget).hasClass('has-bundle')) {
      var link = $(event.currentTarget).data('href');
      $('.warning-drawer .js-remove-item').attr('href', link);
    } else {
      $.ajax(this.makeUpdateAjaxConfig(itemKey, 0))
        .done((function (cart) {
          this.handleItemDeleted(cart, itemKey);
        }).bind(this));
    }
  },

  initRemoveLinks: function () {
    $('.remove-item .icon-close').on('click', this.removeLinkClickHandler.bind(this));
  },
  
  isMobile: function () {
    return window.innerWidth <= ORW.responsiveSizes.large;
  },

});

export default ViewCart;